// src/pages/Home.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import InstallButton from "../InstallButton";
// 1. Import the SEO component
import SEO from "../components/SEO";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="main-content home-view">
      {/* 2. Add the SEO block to explicitely define the page identity */}
      <SEO 
        title="Talkvee - Random Video Chat & Games"
        description="Talkvee is the best free alternative to Omegle. Match up with strangers, play trivia games, and video chat instantly."
        pathname="/"
      />

      <div className="home-container">
        {/* 1. Hero Section */}
        <div className="hero-section">
          {/* SEO FIX: Changed 'div' to 'h1'. 
             We keep the 'logo-badge' class so it LOOKS the same, 
             but Google sees this as the most important text.
          */}
          <h1 className="logo-badge">👋 Talkvee</h1>
          
          {/* SEO FIX: Changed 'h1' to 'h2'.
             This preserves your big font design (assuming .hero-title handles the size),
             but tells Google this is the slogan, not the brand name.
          */}
          <h2 className="hero-title">
            Match Up. <br />
            <span className="highlight-text">Game On.</span>
          </h2>
          
          <p className="hero-subtitle">
            Random video chat with built-in games.
          </p>
        </div>

        {/* 2. Action Area */}
        <div className="action-section">
          <button
            onClick={() => navigate("/chat")}
            className="btn-start-chat"
          >
            <div className="btn-content">
              <span className="icon">📹</span>
              <div className="text-group">
                <span className="btn-title">Start Video Chat</span>
                <span className="btn-sub">Click to find a partner</span>
              </div>
            </div>
            <span className="arrow">→</span>
          </button>

          <div className="secondary-actions">
            <button 
              className="btn-clips" 
              onClick={() => navigate("/clips")}
              style={{
                width: '100%',
                background: 'linear-gradient(45deg, #00b7ffff 0%, #00F2EA 100%)',
                border: 'none',
                borderRadius: '12px',
                padding: '15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: 'bold',
                marginTop: '15px'
              }}
            >
              <span className="icon-small">🎬</span>
              <span className="text-small">Watch VeeClips</span>
            </button>
          </div>
        </div>

        {/* 3. Info Strip */}
        <div className="info-strip">
          <div className="info-item">
            <span className="info-icon">🎮</span>
            <span className="info-label">Trivia</span>
          </div>
          
          <div className="info-divider"></div>
          
          <div className="info-item">
            <span className="info-icon">⭕❌</span>
            <span className="info-label">Tic-Tac-Toe</span>
          </div>

          <div className="info-divider"></div>

          <div className="info-item">
            <span className="info-icon">😂</span>
            <span className="info-label">Laugh Mode</span>
          </div>
          
          <div className="info-divider"></div>

          {/* NEW: Connect 4 */}
          <div className="info-item">
            <span className="info-icon">🔴🟡</span>
            <span className="info-label">Connect 4</span>
          </div>
          
          <div className="info-divider"></div>
          
          <div className="info-item">
            <span className="info-icon">🌍</span>
            <span className="info-label">Global</span>
          </div>
        </div>

        {/* 4. Install Button */}
        <div className="install-wrapper">
          <InstallButton />
        </div>

      </div>
    </div>
  );
}